import { faShieldCheck } from "@jewlr/pro-solid-svg-icons/faShieldCheck"
import { faStar } from "@jewlr/sharp-solid-svg-icons/faStar"
import PropTypes from "prop-types"
// import { Link } from "react-router-dom"

// import Button from "components/ui/button"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
  CarouselScrollSnaps,
} from "components/ui/carousel"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { cn } from "styles/utils"

import { getReviewsData } from "./data"

const ReviewCard = ({ element, review }) => {
  return (
    <CarouselItem className="tablet:pl-16 widescreen:pl-24 xlarge:pl-40 desktop:basis-1/2 large:basis-1/4 pl-8">
      <div
        className={cn(
          "bg-grey-100 text-black-print desktop:p-32 relative flex h-full flex-col px-16 py-24",
          element.style?.card_style?.className
        )}
      >
        <div aria-label="Rating: 5 out of 5 stars" className="mb-16" role="img">
          {new Array(5).fill(null).map((_, i) => (
            <FontAwesomeIcon
              aria-hidden
              className="text-citrine"
              icon={faStar}
              key={`star-${i}`}
            />
          ))}
        </div>

        <p className="tablet:text-18 text-17 widescreen:text-20 mb-16 font-semibold">
          <a
            href={`https://www.trustpilot.com/reviews/${review.id}`}
            rel="noreferrer"
            target="_blank"
          >
            {review.title}
          </a>
        </p>
        <p className="text-15 desktop:mb-20 tablet:text-17 widescreen:text-18 mb-8 font-medium">
          {review.text}
        </p>
        <div className="body-sm mb-16 flex flex-wrap">
          {review.sender && (
            <>
              <p className="mr-8 font-semibold">{review.sender}</p>
              <div className="flex items-center">
                <FontAwesomeIcon
                  className="text-primary text-15 mr-4"
                  icon={faShieldCheck}
                  widthAuto
                />
                <p className="text-primary font-light">Verified Customer</p>
              </div>
            </>
          )}
        </div>
        {/* {review.product && (
          <div className="desktop:mb-40 mt-auto">
            <Button
              asChild
              className="text-12 desktop:text-15 font-medium"
              text
              underline
              variant="primary"
            >
              <Link data-lc="landing-reviews" to={review.product.url}>
                {review.product.title}
              </Link>
            </Button>
          </div>
        )} */}
        <a
          aria-label="View this review on Trustpilot"
          className="desktop:bottom-20 absolute bottom-16 right-20 block"
          href={`https://www.trustpilot.com/reviews/${review.id}`}
          rel="noreferrer"
          target="_blank"
        >
          <Image
            alt="Trustpilot"
            height="278"
            src={require("images/info/reviews/Trustpilot.svg")}
            style={{ width: "74px" }}
            width="1133"
          />
        </a>
      </div>
    </CarouselItem>
  )
}

ReviewCard.propTypes = {
  element: PropTypes.object,
  review: PropTypes.object,
}

const CustomerReviews = ({ element }) => {
  const reviewsData = getReviewsData()

  return (
    <div
      className={cn(
        "widescreen:py-40 py-32",
        element.style?.block_style?.className
      )}
    >
      <div
        className={cn(
          "contained-wide widescreen:items-center tablet:px-32 widescreen:px-60 flex flex-col px-16",
          element.container_style?.className
        )}
      >
        <div
          className="desktop:mb-30 mb-16 flex shrink-0 grow-0 flex-col text-center"
          style={{
            "--widescreen-basis": "406px",
          }}
        >
          <h2 className="text-24 desktop:text-34 text-center font-bold">
            50,000 Five Star Reviews
          </h2>
        </div>
        <div className="overflow-auto">
          <Carousel
            opts={{
              active: true,
              align: "start",
              breakpoints: {
                "(min-width: 1280px)": {
                  active: false,
                },
              },
              loop: false,
              slidesToScroll: "auto",
            }}
          >
            <CarouselContent className="tablet:-ml-16 widescreen:-ml-24 xlarge:-ml-40 -ml-8">
              {reviewsData.map((review, index) => (
                <ReviewCard
                  element={element}
                  key={`${element.id}-${index}`}
                  review={review}
                />
              ))}
            </CarouselContent>
            <div className="large:hidden flex items-center py-10">
              <CarouselScrollSnaps className="static mr-auto inline-flex w-fit" />
              <div className="flex gap-24">
                <CarouselPrevious
                  alwaysShow
                  className="translate-0 static inline-flex"
                />
                <CarouselNext
                  alwaysShow
                  className="translate-0 static inline-flex"
                />
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </div>
  )
}

CustomerReviews.propTypes = {
  element: PropTypes.object,
}

export default CustomerReviews
